import { useState } from 'react';
import {
  Box,
  Button,
  Grow,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import RemoveIcon from '@mui/icons-material/Remove';
import { useExperience } from '../../../experiences/context';

export function FloatingLegend({ layer }) {
  const { isPhone } = useExperience();
  const [open, setOpen] = useState(true);

  if (!layer?.legend) return null;

  const items = layer.legend;

  return (
    <>
      {!open && (
        <Button
          variant="contained"
          color="inherit"
          endIcon={
            <OpenInFullIcon sx={{ '&&': { fontSize: 14 }, mt: '-1px' }} />
          }
          onClick={() => setOpen(true)}
          sx={{
            position: 'absolute',
            bottom: 24,
            right: 12,
            zIndex: 1001,
            bgcolor: 'white',
            color: '#666',
            ...(isPhone && { borderRadius: 4, py: 1.5 }),
          }}
        >
          {layer.name}
        </Button>
      )}

      <Grow in={open} style={{ transformOrigin: 'bottom right' }}>
        <Paper
          elevation={2}
          sx={{
            position: 'absolute',
            bottom: 24,
            right: 12,
            zIndex: 1001,
            p: 1.5,
            pb: 1,
            minWidth: 160,
            ...(isPhone && { borderRadius: 4 }),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: -1,
              mb: -0.5,
            }}
          >
            <Typography variant="subtitle2" sx={{ fontSize: 10 }}>
              {layer.name}
            </Typography>
            <IconButton
              size="small"
              onClick={() => setOpen(false)}
              sx={{ p: 0.5 }}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>
          </Box>
          {items.map(([key, config]) => (
            <Box
              key={key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                py: 0.25,
              }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: 1,
                  bgcolor: config.color,
                  border: config.stroke
                    ? `1px solid ${config.stroke}`
                    : undefined,
                  flexShrink: 0,
                }}
              />
              <Typography variant="caption" sx={{ color: '#666' }}>
                {config.label}
              </Typography>
            </Box>
          ))}
        </Paper>
      </Grow>
    </>
  );
}
